import { ILastLocation } from "./types";

function LastLocationModel(initData: ILastLocation = {}) {
  return {
    status: initData.status,
  };
}

export default LastLocationModel;
